<script>
'use strict';
const { smartenQuotes } = require('../../lib/utils');

module.exports = {
  name: 'SearchHeader',
  data() {
    return {
      placeholderText: '',
      placeholderVisible: false,
      placeholderAnimating: false,
      placeholderInterval: null,
      inputValue: this.$store.state.searchValue || '',
      isFocused: false,
    };
  },
  computed: {
    disclaimerText() {
      return this.$store.state.disclaimerText;
    },
    isStickyOnMobile() {
      return this.$store.state.isStickyOnMobile;
    },
    searchSuggestions() {
      return this.$store.state.searchSuggestions;
    },
  },
  methods: {
    handleSubmit() {
      this.$store.dispatch('submitSearch', { term: this.inputValue });
    },
    clearSearch() {
      this.inputValue = '';
      this.$store.dispatch('submitSearch', { term: '' });
      this.$refs.searchInput.focus();
    },
    startPlaceholderAnimation() {
      const suggestions = this.searchSuggestions;

      if (!suggestions.length) return;

      clearInterval(this.placeholderInterval);

      let index = 0;

      this.placeholderText = suggestions[index++] || '';
      this.placeholderVisible = true;
      this.placeholderAnimating = false;

      this.placeholderInterval = setInterval(() => {
        if (index >= suggestions.length) index = 0;

        this.placeholderAnimating = false;

        setTimeout(() => {
          this.placeholderAnimating = true;

          setTimeout(() => {
            this.placeholderText = suggestions[index++];
          }, 250);
        }, 100);
      }, 3000);
    },
    stopPlaceholderAnimation() {
      clearInterval(this.placeholderInterval);
      this.placeholderInterval = null;
      this.placeholderVisible = false;
      this.placeholderAnimating = false;
    },
    onFocus() {
      this.isFocused = true;
      this.stopPlaceholderAnimation();
    },
    onBlur() {
      this.isFocused = false;
      if (!this.inputValue) {
        this.startPlaceholderAnimation();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.startPlaceholderAnimation();
    });
  },
  beforeDestroy() {
    clearInterval(this.placeholderInterval);
  },
  watch: {
    inputValue(val) {
      if (this.inputValue) {
        const smartened = smartenQuotes(val);
        if (smartened !== val) {
          this.inputValue = smartened;
        }
      }
    },
  },
};
</script>

<template>
  <div class="search-header-container">
    <!-- editorial-note-top lives outside the sticky wrapper so it scrolls away
         naturally; the sentinel fires when the note exits the viewport top,
         which is when .search-wrapper should pin. -->
    <p class="editorial-note editorial-note-top">{{ disclaimerText }}</p>

    <div class="search-input-headline">
      <span class="search-input-headline-mobile">search is in testing</span>
      <span class="search-input-headline-desktop">search is in testing</span>
    </div>

    <div ref="stickysentinel" class="sticky-sentinel" aria-hidden="true"></div>

    <div class="search-wrapper" :class="{ 'is-sticky': isStickyOnMobile }">
      <div class="search-bar" :class="{ 'has-value': inputValue }">
        <div class="search-input-wrapper">
          <div
            v-show="placeholderVisible && !inputValue"
            :class="[
              'search-placeholder',
              { 'slide-up-placeholder': placeholderAnimating },
            ]"
            aria-hidden="true"
            v-html="placeholderText"
          />
          <input
            class="search-input"
            type="text"
            name="search-input"
            v-model="inputValue"
            autocomplete="off"
            @keyup.enter="handleSubmit"
            @focus="onFocus"
            @blur="onBlur"
            ref="searchInput"
          />
        </div>
        <button
          v-if="inputValue"
          class="clear-btn"
          @click="clearSearch"
          aria-label="Clear search"
        >
          <span class="clear-icon"></span>
        </button>
        <span
          class="search-icon-btn"
          aria-hidden="true"
          :style="{ cursor: inputValue ? 'pointer' : 'default' }"
          @click="handleSubmit"
        >
          <span
            :class="[inputValue || isFocused ? 'submit-icon' : 'search-icon']"
          ></span>
        </span>
      </div>

      <p class="editorial-note editorial-note-bottom">{{ disclaimerText }}</p>
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
